export default "__VITE_ASSET__8472e273__"